import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import errorLogger from 'services/monitoring/errorLogger'

errorLogger.init()

ReactDOM.render(
  <React.StrictMode>
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <App />
    </MuiPickersUtilsProvider>
  </React.StrictMode>,
  document.getElementById('root'),
)
